module.exports = __webpack_public_path__ + "static/img/6-5.535b784c.jpg";